import React, { useMemo } from 'react'
import { addLeadingSlash, addTrailingSlash } from '../../utils/urlHelpers'
import { UserSessionResponse } from '../interfaces'
import type { PublicLinksInfo } from '../interfaces/PublicLinks'

type MakePropertyRequired<Type, Key extends keyof Type> = Type & {
  [Property in Key]-?: Type[Property];
}

const initialValue = window.publicLinkInfo ? {
  ...window.publicLinkInfo,
  urlPrefix: window.publicLinkInfo.urlPrefix ? addLeadingSlash(addTrailingSlash(window.publicLinkInfo.urlPrefix)) : "/",
} : {
  urlPrefix: "/",
}

export const PublicLinksInfoContext = React.createContext<
  MakePropertyRequired<PublicLinksInfo, "urlPrefix">
>(
  initialValue
)

export const PublicLinksInfoProvider = ({
  children,
}: {
  children: React.ReactElement
}): React.ReactElement => {

  const sanitisedUrlPrefix = useMemo<string>(
    () => (
      window.publicLinkInfo?.urlPrefix && window.publicLinkInfo.urlPrefix.length > 0 ? addLeadingSlash(addTrailingSlash(window.publicLinkInfo.urlPrefix)) : "/"
    ),
    [window.publicLinkInfo?.urlPrefix]
  )

  const valueToPassDown = useMemo<MakePropertyRequired<PublicLinksInfo, "urlPrefix">>(
    () => ({
      ...window.publicLinkInfo,
      urlPrefix: sanitisedUrlPrefix,
    }),
    [sanitisedUrlPrefix, window.publicLinkInfo]
  )

  return (
    <PublicLinksInfoContext.Provider
      value={valueToPassDown}
    >
      {children}
    </PublicLinksInfoContext.Provider>
  )
}
